import { Link } from 'react-router-dom';

function Terms() {
  return (
    <>
      {/* Page Hero */}
      <section className="page-hero" style={{ backgroundImage: 'linear-gradient(rgba(8, 50, 62, 0.85), rgba(8, 50, 62, 0.85)), url(/images/hero_home.png)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="container">
          <div className="eyebrow" style={{ color: 'var(--gold-light)' }}>Legal Information</div>
          <h1>Terms & Conditions</h1>
          <p>Please read these terms and conditions carefully before using our website.</p>
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <span className="sep">›</span>
            <span className="current">Terms & Conditions</span>
          </div>
        </div>
      </section>

      <section className="section-pad" style={{ background: 'var(--white)' }}>
        <div className="container" style={{ maxWidth: '800px', lineHeight: '1.7', color: 'var(--muted)' }}>
          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>1. Introduction</h3>
          <p style={{ marginBottom: 24 }}>
            Welcome to Mega Health Group (Mega Hospital Foundation), a charitable trust and healthcare organization. By accessing our website or using our services, you agree to the following Terms & Conditions.
          </p>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>2. Nature of Services</h3>
          <p style={{ marginBottom: 24 }}>
            Mega Health Group provides healthcare services on a charitable, subsidized, and affordable basis. Services may include consultations, diagnostics, pathology, imaging, and treatment depending on availability and medical requirement.
          </p>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>3. Medical Disclaimer</h3>
          <p style={{ marginBottom: 24 }}>
            All information provided on this website is for general awareness and educational purposes only. It should not be considered a substitute for professional medical advice, diagnosis, or treatment. Patients are advised to consult qualified medical professionals for any health concerns.
          </p>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>4. Appointments & Services</h3>
          <ul style={{ marginBottom: 24, paddingLeft: 24 }}>
            <li>Appointment requests are subject to confirmation and availability.</li>
            <li>Emergency cases should be directed to the nearest emergency hospital or emergency services.</li>
            <li>The trust reserves the right to prioritize cases based on medical urgency.</li>
          </ul>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>5. Patient Responsibilities</h3>
          <p style={{ marginBottom: 24 }}>
            Patients are responsible for providing accurate and complete information during registration, appointments, and treatment. The hospital reserves the right to refuse services in accordance with applicable laws and hospital policies.
          </p>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>6. Patient Information</h3>
          <p style={{ marginBottom: 24 }}>
            Patients are required to provide accurate, complete, and truthful information during registration and treatment. Any incorrect information may affect diagnosis and treatment.
          </p>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>7. Charitable & Subsidized Care</h3>
          <p style={{ marginBottom: 12 }}>As a trust organization, Mega Health Group may provide:</p>
          <ul style={{ marginBottom: 12, paddingLeft: 24 }}>
            <li>Free or subsidized treatment based on eligibility and financial condition</li>
            <li>Charity-based medical support at the discretion of management</li>
          </ul>
          <p style={{ marginBottom: 24 }}>
            All such services are subject to internal approval and availability of resources.
          </p>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>8. Insurance & Billing</h3>
          <p style={{ marginBottom: 24 }}>
            We accept selected government and private health insurance schemes. Coverage is subject to insurance provider approval, policy terms, and hospital verification. Any non-covered expenses will be the responsibility of the patient.
          </p>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>9. Data & Confidentiality</h3>
          <p style={{ marginBottom: 24 }}>
            All patient records and personal information are kept strictly confidential and used only for medical, diagnostic, and legal purposes in accordance with applicable healthcare standards.
          </p>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>10. Website Usage</h3>
          <p style={{ marginBottom: 24 }}>
            Users agree not to misuse the website for fraudulent, illegal, or harmful activities. We are not responsible for any technical errors, interruptions, or inaccuracies in website content.
          </p>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>11. External Links</h3>
          <p style={{ marginBottom: 24 }}>
            Our website may contain links to third-party services. We are not responsible for the content or privacy practices of external websites.
          </p>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>12. Changes to Terms</h3>
          <p style={{ marginBottom: 24 }}>
            Mega Health Group (Mega Hospital Foundation) reserves the right to update or modify these Terms & Conditions at any time without prior notice. Updates will be posted on this page.
          </p>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>13. Governing Principles</h3>
          <p style={{ marginBottom: 24 }}>
            All services are governed by applicable laws and ethical standards for healthcare institutions and charitable trusts.
          </p>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>14. Contact Information</h3>
          <p style={{ marginBottom: 24 }}>
            For any queries regarding these Terms & Conditions, please contact us through our official hospital communication channels.
          </p>
        </div>
      </section>
    </>
  );
}

export default Terms;
